import { useContext } from 'react';
import GlobalStateContext from '../../context/GlobalStateContext';

function useUserDetails() {
  const { userDetails, pubNubToken } = useContext(GlobalStateContext);

  return { userDetails, pubNubToken };
};

export default useUserDetails;